export default "__VITE_PUBLIC_ASSET__42ce2c5f__"